import { AuthConfig } from '../types';

// Get the current origin (protocol + hostname + port) from the browser
const getCurrentOrigin = (): string => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return 'http://localhost:5173'; // Fallback for SSR
};

// Configuration is loaded from environment variables (.env.dev or .env.prod)
// Redirect URLs always use the current browser origin for flexibility between localhost and deployed environments
export const authConfig: AuthConfig = {
  userPoolId: import.meta.env.VITE_USER_POOL_ID || '',
  userPoolWebClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '',
  domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
  redirectSignIn: getCurrentOrigin(),
  redirectSignOut: getCurrentOrigin(),
  apiUrl: import.meta.env.VITE_API_URL || '',
};

export const getAuthUrl = (type: 'login' | 'logout'): string => {
  const { domain, userPoolWebClientId, redirectSignIn, redirectSignOut } = authConfig;

  if (type === 'login') {
    // Use authorization code flow (response_type=code) instead of implicit flow (response_type=token)
    // This enables refresh tokens for persistent sessions
    return `${domain}/oauth2/authorize?client_id=${userPoolWebClientId}&response_type=code&scope=email+openid+profile&redirect_uri=${encodeURIComponent(redirectSignIn)}&identity_provider=Google`;
  } else {
    return `${domain}/logout?client_id=${userPoolWebClientId}&logout_uri=${encodeURIComponent(redirectSignOut)}`;
  }
};
